<template>
  <div>        
    <v-card style="min-height: 100vh">
      <v-toolbar
        dark
        flat
      >
        <v-icon
          left
        >
          mdi-account-edit
        </v-icon>
        {{ editUser.id ? 'Edit' : 'Create' }} User
        <v-spacer/>
        <v-btn
          fab
          flat
          dark
          @click="$emit('stopEditing')"
        >
          x
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs4
            style="text-align:center; margin-top:25px"
          >
            <v-icon
              size="155"
              color="primary">
              mdi-account-circle
            </v-icon>
            <div style="text-align:left">
              <span style="font-size:24px">{{editUser.first_name}} {{editUser.last_name}}</span><br/>
              <span><b>Username: </b>{{ editUser.username }}</span><br/>
              <span><b>Email: </b>{{ editUser.email }}</span><br/>
              <span><b>Date Created: </b>{{ editUser.date_joined }}</span><br/>
              <v-switch
                v-if="editUser.id" 
                v-model="editUser.is_active"
                label="Enabled"
              />
              <v-switch 
                v-if="editUser.id"
                v-model="editUser.is_org_admin"
                messages="This grants a user access to your organization branding and user management."
                label="Is Admin ?"
              />
              <br />
              <v-btn
                v-if="editUser.id"
                color="#FFEA00"
                @click="$emit('resetPassword')"
              >
                Reset Password
              </v-btn>
            </div>
          </v-flex>
          <v-flex>
            <v-form ref="editForm">
              <v-container
                fluid
              >
                <v-card>
                  <v-toolbar
                    dense
                    flat
                  >
                    Account Information
                  </v-toolbar>
                  <v-card-text>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex 
                        xs12 
                        md6 
                      >
                        <v-text-field
                          v-model="editUser.last_name"
                          autofocus
                          label="Last Name"
                          class="lastName"
                          :rules="rules.lastName"
                        />
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editUser.first_name"
                          label="First Name"
                          :rules="rules.firstName"
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs12>
                        <v-text-field
                          v-model="editUser.username"
                          label="Username"
                          :rules="rules.username"
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editUser.email"
                          label="Email"
                          :rules="rules.email"
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editUser.phone"
                          label="Mobile Phone"
                          :rules="rules.phoneNumber"
                        />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
                <v-card
                  v-if="editUser.id"
                  style="margin-top:2em"
                >
                  <v-toolbar
                    flat 
                    dense
                  >
                    Notification Preferences
                    <span style="font-weight:700;">
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <span v-if="tagStatus === 'saving'">
                        Saving Preferences...
                      </span>
                      <span v-if="tagStatus === 'saved'">
                        Preferences Saved!
                      </span>
                      <span v-if="tagStatus === 'error'">
                        !! Something went wrong !!
                      </span>
                    </span>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs12 sm6>
                        <span>How would you like to receive notifications?</span>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-switch
                          v-model="editUser.notify_by_email"
                          style="display:inline"
                          label="Via Email"
                          :hint="editUser.email"
                          persistent-hint
                        />
                      </v-flex>
                    </v-layout>
                    <br />
                    <hr />
                    <br />
                    <p style="font-weight: 500; font-size: 18px">Form Subscriptions</p>
                    <div
                      v-for="tag in formTagSubs"
                      :key="tag.tag"
                    >
                      <v-layout
                        row
                        wrap
                      >
                        <v-flex xs12 sm3 style="display:flex;justify-content: space-between; align-items: baseline;">
                          <v-chip
                            label
                            small
                          >
                            {{ tag.tag }}
                          </v-chip>
                          <v-icon
                            small 
                            style="margin-left: auto; margin-right: 2em"
                            @click="deleteFormSub(tag)"
                          >
                            mdi-delete-off
                          </v-icon>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-switch
                            v-model="tag.on_client_start"
                            style="display:inline;"
                            label="On Client Start"
                            @change="updateFormTag(tag)"
                          />
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-switch
                            v-model="tag.on_client_submit"
                            style="display:inline;"
                            label="On Client Submit"
                            @change="updateFormTag(tag)"
                          />
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-switch
                            v-model="tag.on_client_sign"
                            style="display:inline;"
                            label="On Client Signing"
                            @change="updateFormTag(tag)"
                          />
                        </v-flex>
                      </v-layout>
                    </div>
                    <v-btn
                      small
                      v-if="!addFormTag"
                      @click="addFormTag = true"
                    >
                      <v-icon small left>add</v-icon>
                      Add Form Subscription
                    </v-btn>
                    <v-expand-transition>
                      <div v-if="addFormTag">
                        <v-autocomplete
                          v-model="filterFormTags"
                          :items="tagFormResults"
                          item-text="tag"
                          :search-input.sync="tagFormSearch"
                          label="Search for a Tag"
                          dense
                          hide-details
                          return-object
                        />
                      </div>
                    </v-expand-transition>
                    <br/>
                    <br/>
                    <p style="font-weight: 500; font-size: 18px">Contact Subscriptions</p>
                    <div
                      v-for="tag in contactTagSubs"
                      :key="tag.slug"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 sm4 style="display:flex;justify-content: space-between; align-items: baseline;">
                          <v-chip
                            small
                            label 
                          >
                            {{ tag.tag }}
                          </v-chip>
                          <span style="display:inline-flex">
                            <v-icon
                              small 
                              style="margin-left: auto; margin-right: 6em"
                              @click="deleteContactSub(tag)"
                            >
                              mdi-delete-off
                            </v-icon>
                          </span>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-switch
                            v-model="tag.on_client_file_upload"
                            label="On Client File Upload"
                            style="display:inline"
                            @change="updateContactTag(tag)"
                          />
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-switch
                            v-model="tag.on_client_message"
                            style="display: inline"
                            label="On Client Communication"
                            @change="updateContactTag(tag)"
                          />
                        </v-flex>
                      </v-layout>
                    </div>
                    <v-btn
                      small
                      v-if="!addContactTag"
                      @click="addContactTag = true"
                    >
                      <v-icon 
                        small 
                        left
                      >
                        add
                      </v-icon>
                      Add Contact Subscription
                    </v-btn>
                    <v-expand-transition>
                      <div v-if="addContactTag">
                        <v-autocomplete
                          v-model="filterContactTags"
                          :items="tagContactResults"
                          :search-input.sync="tagContactSearch"
                          label="Search for a Tag"
                          item-text="tag"
                          dense
                          hide-details
                          return-object
                        />
                      </div>
                    </v-expand-transition>
                  </v-card-text>
                </v-card>
                <v-card
                  v-if="!editUser.id"
                  style="margin:15px"
                >
                  <v-card-text>
                    <v-layout 
                      row 
                      wrap
                    > 
                      <v-flex>
                        <v-text-field 
                          v-model="editUser.password"
                          :rules="[v => !!v || 'Password is required']"
                          type="password"
                          label="Temporary Password"
                          autocomplete="new-password"
                        />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          flat
          @click="$emit('stopEditing')"
        >
          Cancel
        </v-btn>
        <v-btn
          flat
          color="blue"
          :disabled="saving"
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card> 
  </div>
</template>

<script>
import api from '@/api'
export default{
  
    name: 'UserEditor',
    props: ['user'],
    data () {
        return {
            editUser: this.user,
            tagStatus: "",
            tagSearchStorage: [],
            tagFormSearch: null,
            tagContactSearch: null,
            formTagSubs: [],
            addFormTag: false,
            addContactTag: false,
            contactTagSubs: [], 
            filterFormTags: null,
            filterContactTags: null,
            errorMessages: [],
            minChars: 0,
            rules: {
              firstName: [v => (v || '').length > this.minChars || "Must enter first name"],
              lastName: [v => (v || '').length > this.minChars || "Must enter last name"],
              email: [v => /^.+@.+$|^$/.test(v) || 'E-mail must be valid'],
              password: [v => !!v || 'Password is required'],
              username: [v => !!v || 'Username is required'],
              phoneNumber: [v => (/^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/.test(v) || !v ) || "Must have a valid phone number"]
            },
            saving: false
        }
    },
    computed: {
      tagFormResults() {
        return this.tagSearchStorage.filter(object => {
          var exists = false;
          this.formTagSubs.forEach(tagObject => {
            if(tagObject.tag === object.tag){
              exists = true;
            }
          });
          if(!exists) {
            return object;
          }
        })
      },
      tagContactResults() {
        return this.tagSearchStorage.filter(object => {
          var exists = false
          this.contactTagSubs.forEach(tagObject => {
            if (tagObject.tag === object.tag) {
              exists = true
            }
          })
          if (!exists) {
            return object
          }
        })
      }
    },
    watch: {
      tagContactSearch() {
        if (this.$data.tagContactSearch) {
          this.fetchContactTags()
        }
      },
      tagFormSearch() {
        if (this.$data.tagFormSearch) {
          this.fetchFormTags()
        }
      },
      filterFormTags() {
        this.addFormTag = false;
        if (this.$data.filterFormTags !== null) {
          this.formTagSubs.push(this.$data.filterFormTags)
          this.$data.tagFormSearch = null;
          this.tagSearchStorage = [];
          this.$data.filterFormTags = null
        }
      },
      filterContactTags() {
        this.addFormTag = false;
        if(this.$data.filterContactTags !== null) {
          this.contactTagSubs.push(this.$data.filterContactTags)
          this.$data.tagContactSearch = null
          this.tagSearchStorage = []
          this.$data.filterContactTags = null
        }
      }
    },
    methods: {
      save(){
        this.saving = true
        if(this.$refs.editForm.validate()){
          this.$emit('saveUser', this.editUser)
        }
      },
      fetchFormTags() {
        api.userform.userformTags.get( this.tagFormSearch)
          .then(tagResults => {
            this.tagSearchStorage = tagResults;
          });
      },
      fetchContactTags() {
        api.userform.contactTags.get(this.tagContactSearch)
          .then(tagResults => {
            this.tagSearchStorage = tagResults;
          })
      },
      updateFormTag(tag) {
        this.tagStatus = 'saving'
        api.userform.adminUserformTags.updateSub(this.editUser.id, tag)
          .then(() => {
            this.tagStatus = 'saved'
          })
          .catch(() => {
            this.tagStatus = 'error'
          })
      },
      deleteFormSub(tag) {
        this.tagStatus = 'saving'
        api.userform.adminUserformTags.deleteSub(this.editUser.id, tag)
          .then(() => {
            this.tagStatus = 'saved'
            this.formTagSubs = this.formTagSubs.filter((oldTag) => {
              if (oldTag !== tag){
                return oldTag;
              }
            })
          })
          .catch(() => {
            this.tagStatus = 'error'
          })
      },
      updateContactTag(tag) {
        this.tagStatus = 'saving'
        api.userform.adminContactTags.updateSub(this.editUser.id, tag)
          .then(() => {
            this.tagStatus = 'saved'
          })
          .catch(() => {
            this.tagStatus = 'error'
          })
      },
      deleteContactSub(tag) {
        this.tagStatus = 'saving'
        api.userform.adminContactTags.deleteSub(this.editUser.id, tag)
          .then(() => {
            this.tagStatus = 'saved'
          })
          .catch(() => {
            this.tagStatus = 'error'
          })
      }
    },
    mounted(){
      if(this.editUser.id){
        api.userform.adminUserformTags.getSubs(this.editUser.id)
          .then(formTags => {
            this.formTagSubs = formTags
          })
        api.userform.adminContactTags.getSubs(this.editUser.id)
          .then(contactTags => {
            this.contactTagSubs = contactTags
          })
      }
    }
}
</script>

<style>
  @media (min-width:960px) {
    .lastName{
      margin-right: 1em;
    }
  }
</style>